import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, first } from 'rxjs/operators';
import { AccountStoreService } from '../../store/account.store.service';
import { Account } from '../../models/account';

@Injectable()
export class AccountResolver implements Resolve<Account> {
  constructor(private accountStoreService: AccountStoreService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Account> {
    const acountId = route.params['id'];

    if (acountId) {
      return this.accountStoreService.getAccountById(acountId).pipe(
        tap((account) => {
          if (!account) {
            this.accountStoreService.fetchAccountById(acountId);
          }
        }),
        first()
      );
    } else {
      return of(null);
    }
  }
}
